import { render, staticRenderFns } from "./SFInternalTabsDetailsPopup.vue?vue&type=template&id=47d5e498&lang=html"
import script from "./SFInternalTabsDetailsPopup.vue?vue&type=script&lang=js"
export * from "./SFInternalTabsDetailsPopup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports